<p-dialog [(visible)]="showMissingWarning" [modal]="true" [closable]="true" [style]="{width: '500px'}">
	<ng-template pTemplate="header">
		<i class="pi pi-exclamation-triangle" style="color: #f59e0b; font-size: 1.4rem; margin-right: 0.5rem;"></i>
		<span class="p-dialog-title">Missing Substitution Fields</span>
	</ng-template>
	<p>The employer has been saved. However, this employer is missing substitution fields for the following campaigns and will be skipped at send time:</p>
	<ul style="margin-top: 0.75rem; padding-left: 1.5rem;">
		<li *ngFor="let c of missingCampaigns">{{ c.campaignName }}</li>
	</ul>
	<ng-template pTemplate="footer">
		<button pButton label="Got It" (click)="showMissingWarning = false"></button>
	</ng-template>
</p-dialog>
<div class="tabs" [ngSwitch]="activeTab" *ngIf="employer">
	<div class="tab" *ngSwitchCase="'configure'" [formGroup]="form">
		<div class="grid">
			<div class="field">
				<div class="label">Employer Name</div>
				<div><input pInputText [formControlName]="'employerName'" /></div>
			</div>
			<div class="field">
				<div class="label">Web Site Path (yourpathhere.onemorning.com)</div>
				<div><input pInputText [formControlName]="'path'" /></div>
			</div>
			<div class="field-group side-by-side">
				<div class="field">
					<div class="label">Logo</div>
					<div class="company-logo">
						<img [src]="employer.logo" [alt]="employer.employerName + ' Logo'" *ngIf="employer.logo" />
					</div>
					<div class="actions">
						<app-file-upload [(id)]="employer.employerLogoUploadID" (fileUploaded)="onLogoUpload($event)" [showPreview]="false"></app-file-upload>
						<div class="button danger" (click)="deleteLogo()">Delete Logo</div>
					</div>
				</div>
				<div class="field" *ngIf="employer.qrCode">
					<div class="label">QR Code</div>
					<div class="qr-code">
						<img [src]="employer.qrCode" [alt]="employer.employerName + ' QR Code'" />
						<div (click)="copyImage()" class="action"><span class="material-symbols-outlined" title="Copy QR Code">content_copy</span></div>
						<div class="action">
							<a [href]="'api/employers/' + employer.employerID + '/qr'" download="{{ employer.employerName }}_qr_code.png"><span class="material-symbols-outlined" title="Download QR Code">download</span></a>
						</div>
					</div>
				</div>
			</div>
			<div class="field">
				<div class="label">
					Drip Start Date
					<span class="material-symbols-outlined info-icon" [pTooltip]="'Sets the first day of the Drip schedule for this employer. No Drip emails will be sent unless a start date is set.'" tooltipPosition="top" [appendTo]="'body'" tooltipStyleClass="tooltip-wrap">info</span>
				</div>
				<div><p-calendar [formControlName]="'dripStartDate'" dateFormat="mm/dd/yy" [showIcon]="true"></p-calendar></div>
			</div>
			<div class="field">
				<div class="label">Campaign Delivery Type</div>
				<div>
					<p-dropdown [options]="deliveryTypes" [(ngModel)]="selectedDeliveryType" optionLabel="deliveryTypeDesc" optionValue="deliveryTypeID" [autoDisplayFirst]="false" [ngModelOptions]="{ standalone: true }"></p-dropdown>
				</div>
			</div>
			<div class="field">
				<div class="label">
					Drip Program
					<span class="material-symbols-outlined info-icon" [pTooltip]="'Sets the Drip Program that will be used for this Employer. No drip emails will be sent unless this field is set.'" tooltipPosition="top" [appendTo]="'body'" tooltipStyleClass="tooltip-wrap">info</span>
				</div>
				<div>
					<p-dropdown [options]="dripPrograms" [(ngModel)]="selectedDripProgram" optionLabel="dripProgramDesc" optionValue="dripProgramID" [autoDisplayFirst]="false" [ngModelOptions]="{ standalone: true }" placeholder="Select a Drip Program" [showClear]="true"></p-dropdown>
				</div>
			</div>
			<div class="field" *ngIf="selectedDeliveryType === 1 || selectedDeliveryType === 2 || selectedDeliveryType === 3">
				<div class="label">SMS Opt-In Start Date</div>
				<div><p-calendar [formControlName]="'smsOptInStart'" dateFormat="mm/dd/yy" [showIcon]="true" [showTime]="true" [hourFormat]="'12'"></p-calendar></div>
			</div>
		</div>
	</div>
	<div class="tab" *ngSwitchCase="'customizations'">
		<ng-container *ngFor="let category of employer.employerContent.contentCategories">
			<div class="category">
				<h3>{{ category.contentCategoryDesc }}</h3>
				<div class="content">
					<div class="fields">
						<ng-container *ngFor="let content of category.content">
					<div class="field" *ngIf="isCtaFieldVisible(content, category)" [ngClass]="{ 'has-error': !!content.error }">
							<div class="label">
								<span>{{ content.contentDesc }}</span>
								<div class="reset-button button neutral" *ngIf="content.textContent != content.defaultTextContent" (click)="resetText(content)">Reset to Default</div>
							</div>
							<ng-container [ngSwitch]="content.contentTypeID">
								<div class="value" *ngSwitchCase="1">
									<textarea pInputTextarea [(ngModel)]="content.textContent" [autoResize]="true" (focus)="editingField = content.contentID" (blur)="editingField = ''" [ngClass]="{ editing: contentField == content.contentID }"></textarea>
								</div>
								<div class="value" *ngSwitchCase="2">
									<input pInputText [(ngModel)]="content.textContent" (focus)="editingField = content.contentID" (blur)="editingField = ''" [ngClass]="{ editing: contentField == content.contentID }" />
								</div>
								<div class="value" *ngSwitchCase="5">
									<div class="file-upload-container">
										<app-file-upload [(id)]="content.fileUploadID" [thumbnail]="content.fileContent" (fileUploaded)="onFileUpload($event, content)" (fileRemoved)="onContentFileRemoved(content)"></app-file-upload>
									</div>
								</div>
								<div class="value" *ngSwitchCase="6">
									<p-inputSwitch [(ngModel)]="content.boolContent" (onChange)="setCheckboxValue($event, content)"></p-inputSwitch>
								</div>
								<div class="value" *ngSwitchCase="8">
									<p-editor [(ngModel)]="content.textContent" [style]="{'height':'200px'}" (onFocus)="editingField = content.contentID" (onBlur)="editingField = ''">
										<ng-template pTemplate="header">
											<span class="ql-formats">
												<select class="ql-header">
													<option value="1">Heading 1</option>
													<option value="2">Heading 2</option>
													<option value="3">Heading 3</option>
													<option selected>Normal</option>
												</select>
											</span>
											<span class="ql-formats">
												<button type="button" class="ql-bold"></button>
												<button type="button" class="ql-italic"></button>
												<button type="button" class="ql-underline"></button>
												<button type="button" class="ql-strike"></button>
											</span>
											<span class="ql-formats">
												<select class="ql-color"></select>
												<select class="ql-background"></select>
											</span>
											<span class="ql-formats">
												<button type="button" class="ql-list" value="ordered"></button>
												<button type="button" class="ql-list" value="bullet"></button>
											</span>
											<span class="ql-formats">
												<select class="ql-align"></select>
											</span>
											<span class="ql-formats">
												<button type="button" class="ql-link"></button>
												<button type="button" class="ql-image"></button>
											</span>
										</ng-template>
									</p-editor>
								</div>
								<div class="value" *ngSwitchCase="9">
									<p-dropdown
										[options]="getDropdownOptions(content.defaultTextContent)"
										[(ngModel)]="content.textContent"
										placeholder="Select..."
										[showClear]="true"
										(onChange)="onCtaTypeChange(content)">
									</p-dropdown>
								</div>
							</ng-container>
							<div class="error" *ngIf="content.error">{{ content.error }}</div>
						</div>
						</ng-container>
					</div>
					<div class="preview">
						<img [src]="category.helperImage" alt="" />
						<ng-container *ngFor="let content of category.content">
							<!-- Custom content fields (contentTypeID = 8) should not appear in the preview -->
							<div class="box" *ngIf="content.previewTop && content.contentTypeID !== 8" [ngStyle]="content.style" [ngClass]="{ editing: editingField == content.contentID }" (click)="setContentField(content.contentID)">{{ content.textContent }}</div>
						</ng-container>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
	<div class="tab" *ngSwitchCase="'video-cards'">
		<div class="video-cards">
			<ng-container *ngFor="let card of videoCards">
				<app-admin-card [cardData]="card" [canDelete]="true" [canEdit]="!!card.employerID" (onAddRemoveCard)="setCardInclusion($event)" (onEditCard)="editCard(card)"></app-admin-card>
			</ng-container>
		</div>
		<div *ngIf="videoCards.length == 0">
			<h3>No Video Cards have been set up for this employer. Click the "Add New" button above to get started.</h3>
		</div>
	</div>
	<div class="tab" *ngSwitchCase="'topic-cards'">
		<div class="topic-cards">
			<ng-container *ngFor="let card of topicCards">
				<app-admin-card [cardData]="card" [canDelete]="true" [canEdit]="!!card.employerID" (onAddRemoveCard)="setCardInclusion($event)" (onEditCard)="editCard(card)"></app-admin-card>
			</ng-container>
		</div>
		<div *ngIf="topicCards.length == 0">
			<h3>No Topic Cards have been set up for this employer. Click the "Add New" button above to get started.</h3>
		</div>
	</div>
	<div class="tab" *ngSwitchCase="'library'">
		<div class="library-tab">
			<div class="docs">
				<p *ngIf="allDocuments.length == 0">No documents to show</p>
				<app-library-item [document]="document" *ngFor="let document of documentsToShow" [buttons]="isSuperAdmin ? (document.employerID ? ['edit', 'delete', 'download'] : ['remove', 'download']) : ['download']" (onEditClick)="editDocument($event)" (onDeleteClick)="deleteDocument($event)" (onRemoveClick)="removeDocument($event)"> </app-library-item>
			</div>
			<div class="tags">
				<app-tags [(selectedTagIds)]="selectedTagIds" (selectedTagIdsChange)="filterDocuments()"></app-tags>
			</div>
		</div>
	</div>
	<div class="tab" *ngSwitchCase="'census-data'">
		<div class="census-data">
			<h2>Upload Census Data File Process<span class="material-symbols-outlined" (click)="showCensusUploadDialog = true">info</span></h2>
			<div class="upload-field">
				<p-fileUpload mode="basic" accept=".csv" (onSelect)="uploadCensusData($event)" #censusUploadField></p-fileUpload>
				<div class="button neutral" (click)="clearCensusFile()" *ngIf="censusUploadField.files.length > 0">Clear</div>
			</div>
		</div>
	</div>
</div>

<ng-container *ngIf="employer">
	<div class="mask" *ngIf="showAddCardDialog">
		<div class="dialog">
			<h2>Add Card</h2>
			<div class="dialog-content">
				<app-add-card [cardContainerID]="addingCardContainerID" [employerID]="employer.employerID" [existingCards]="existingCards" (onClose)="closeAddCardDialog()"></app-add-card>
			</div>
		</div>
	</div>
</ng-container>

<ng-container *ngIf="editingCard">
	<div class="mask" *ngIf="showEditCardDialog">
		<div class="dialog">
			<h2>Edit Card</h2>
			<div class="dialog-content">
				<app-edit-card [cardData]="editingCard" (onClose)="closeEditCardDialog()"></app-edit-card>
			</div>
		</div>
	</div>
</ng-container>

<ng-container *ngIf="cardsToReorder">
	<div class="mask" *ngIf="showReorderDialog">
		<div class="dialog">
			<h2>Reorder Cards</h2>
			<div class="dialog-content">
				<p-orderList [value]="cardsToReorder" [dragdrop]="true">
					<ng-template let-card pTemplate="item">
						<div class="card">{{ card.title }}</div>
					</ng-template>
				</p-orderList>
			</div>
			<div class="actions">
				<div class="button neutral" (click)="closeReorderDialog()">Cancel</div>
				<div class="button success" (click)="saveCardOrder()">Save</div>
			</div>
		</div>
	</div>
</ng-container>

<ng-container *ngIf="documentsToReorder">
	<div class="mask" *ngIf="showReorderDocumentsDialog">
		<div class="dialog">
			<h2>Reorder Documents</h2>
			<div class="dialog-content">
				<p-orderList [value]="documentsToReorder" [dragdrop]="true">
					<ng-template let-doc pTemplate="item">
						<div class="card">{{ doc.docTitle }}</div>
					</ng-template>
				</p-orderList>
			</div>
			<div class="actions">
				<div class="button neutral" (click)="closeReorderDocumentsDialog()">Cancel</div>
				<div class="button success" (click)="saveDocumentOrder()">Save</div>
			</div>
		</div>
	</div>
</ng-container>

<ng-container *ngIf="showAddNewDocumentDialog">
	<div class="mask" *ngIf="showAddNewDocumentDialog">
		<div class="dialog">
			<h2>Add Document</h2>
			<div class="dialog-content">
				<app-add-document (onClose)="closeAddDocumentDialog()" (onSave)="selectedTagIds = []; refreshDocs()" [employerID]="employer.employerID" [existingDocuments]="allDocuments"></app-add-document>
			</div>
		</div>
	</div>
</ng-container>

<ng-container *ngIf="showEditDocumentDialog"></ng-container>
<div class="mask" *ngIf="showEditDocumentDialog">
	<div class="dialog">
		<h2>Edit Document</h2>
		<div class="dialog-content">
			<app-edit-document [document]="editingDocument" (onClose)="closeEditDocumentDialog()" (onSave)="onDocumentSaved($event)"></app-edit-document>
		</div>
	</div>
</div>

<app-confirm-dialog
	[confirmHeader]="'Are you sure?'"
	[confirmBodyMsg]="'Are you sure you want to delete this employer?'"
	[showDialog]="showDeleteEmployerConfirmation"
	[buttons]="[
		{ text: 'Cancel', class: 'neutral' },
		{ text: 'Delete', class: 'danger' },
	]"
	(onClick)="onConfirmClick($event)"
></app-confirm-dialog>

<app-confirm-dialog
	[confirmHeader]="'Delete Permanently?'"
	[confirmBodyMsg]="'Do you want to temporarily hide this card from this employer\'s site, or delete it permanently?'"
	[showDialog]="showDeleteCardConfirmation"
	[data]="deletingCardId"
	[buttons]="[
		{ text: 'Hide Temporarily', class: 'danger' },
		{ text: 'Delete Permanently', class: 'danger' },
		{ text: 'Cancel', class: 'neutral' },
	]"
	(onClick)="onConfirmClick($event)"
></app-confirm-dialog>

<app-confirm-dialog
	[confirmHeader]="'Save Changes First?'"
	[confirmBodyMsg]="'You have pending changes.  Do you want to save them before previewing?'"
	[showDialog]="showSaveChangesConfirmation"
	[buttons]="[
		{ text: 'Save Changes', class: 'success' },
		{ text: 'Preview without Saving', class: 'neutral' },
	]"
	(onClick)="onConfirmClick($event)"
></app-confirm-dialog>

<app-confirm-dialog
	[confirmHeader]="'Are you sure?'"
	[confirmBodyMsg]="'Are you sure you want to delete this document permanently?'"
	[showDialog]="showDeleteDocumentConfirmation"
	[data]="deletingDocumentId"
	[buttons]="[
		{ text: 'Cancel', class: 'neutral' },
		{ text: 'Delete Document', class: 'danger' },
	]"
	(onClick)="onConfirmClick($event)"
></app-confirm-dialog>

<app-confirm-dialog
	[confirmHeader]="'Are you sure?'"
	[confirmBodyMsg]="'Are you sure you want to remove this document?'"
	[showDialog]="showRemoveDocumentConfirmation"
	[data]="deletingDocumentId"
	[buttons]="[
		{ text: 'Cancel', class: 'neutral' },
		{ text: 'Remove Document', class: 'danger' },
	]"
	(onClick)="onConfirmClick($event)"
></app-confirm-dialog>

<app-confirm-dialog
	[confirmHeader]="'Confirm URL update'"
	[confirmBodyMsg]="'Changing the path will rebuild the employer QR Code.  QR codes than have already been distributed will no longer work properly.  Are you sure you want to change the path?'"
	[showDialog]="showPathUpdateConfirmation"
	[data]="null"
	[buttons]="[
		{ text: 'Cancel', class: 'neutral' },
		{ text: 'Continue Saving', class: 'danger' },
	]"
	(onClick)="onConfirmClick($event)"
></app-confirm-dialog>

<p-dialog header="Uploading Census File" [(visible)]="showCensusUploadDialog" [style]="{ width: '50vw' }" [modal]="true">
	<div class="census-file-dialog">
		<div class="census-file-dialog-header">
			<img src="/assets/images/one-morning-blk.png" alt="One Morning" />
		</div>
		<h3>Employee Census File Upload Process</h3>
		<p>To ensure our email messages effectively reach your employees, we need your help in uploading an employee census via CSV file on your dedicated microsite. Listed below is the step-by-step process on how to do this:</p>
		<ol>
			<li>
				<span>Compile a CSV census file of your employees including the following data :</span>
				<ol>
					<li>First Name</li>
					<li>Last Name</li>
					<li>Email Address</li>
					<li>Phone Number</li>
					<li>Employee Category</li>
				</ol>
				<a (click)="downloadSampleFile()">Download a sample CSV file</a> to use as a template.
			</li>
			<li>Log on to https://admin.onemorning.com/admin/login using the credentials provided to you.</li>
			<li>Navigate to the “Census Data” tab.</li>
			<li>
				Click the
				<span class="button neutral">
					<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="p-button-icon p-button-icon-left p-icon pi">
						<g clip-path="url(#pn_id_4)">
							<path
								d="M7.67742 6.32258V0.677419C7.67742 0.497757 7.60605 0.325452 7.47901 0.198411C7.35197 0.0713707 7.17966 0 7 0C6.82034 0 6.64803 0.0713707 6.52099 0.198411C6.39395 0.325452 6.32258 0.497757 6.32258 0.677419V6.32258H0.677419C0.497757 6.32258 0.325452 6.39395 0.198411 6.52099C0.0713707 6.64803 0 6.82034 0 7C0 7.17966 0.0713707 7.35197 0.198411 7.47901C0.325452 7.60605 0.497757 7.67742 0.677419 7.67742H6.32258V13.3226C6.32492 13.5015 6.39704 13.6725 6.52358 13.799C6.65012 13.9255 6.82106 13.9977 7 14C7.17966 14 7.35197 13.9286 7.47901 13.8016C7.60605 13.6745 7.67742 13.5022 7.67742 13.3226V7.67742H13.3226C13.5022 7.67742 13.6745 7.60605 13.8016 7.47901C13.9286 7.35197 14 7.17966 14 7C13.9977 6.82106 13.9255 6.65012 13.799 6.52358C13.6725 6.39704 13.5015 6.32492 13.3226 6.32258H7.67742Z"
								fill="currentColor"
							></path>
						</g>
						<defs>
							<clipPath id="url(#pn_id_4)"><rect width="14" height="14" fill="white"></rect></clipPath>
						</defs></svg
				></span>
				button.
			</li>
			<li>Select your file and add.</li>
			<li>Once uploaded, you will see a button in the upper right-hand corner of your screen that allows you to download the current data in the system so you can verify what has been uploaded.</li>
		</ol>
	</div>
</p-dialog>

<p-dialog header="Content Rules Guide" [(visible)]="showContentRulesDialog" [style]="{ width: '60vw', maxHeight: '80vh' }" [modal]="true">
	<div class="content-rules-dialog">
		<div class="content-rules-header">
			<img src="/assets/images/one-morning-blk.png" alt="One Morning" />
		</div>
		<h3>Content Rules Summary for Home and Learn More Pages</h3>

		<h4>CTA Buttons</h4>
		<div class="rule-section">
			<p><strong>Overview</strong></p>
			<ul>
				<li>Up to two CTA buttons can be configured in the "CTA Buttons" category</li>
				<li>Each button has a Type selector: None, Visit EAP, or Call EAP</li>
				<li>Set Type to "None" or leave empty to hide a button</li>
			</ul>

			<p><strong>Visit EAP Button</strong></p>
			<ul>
				<li>Requires a URL (the EAP website link)</li>
				<li>Optionally shows a Group Code with a customizable label</li>
				<li>Default button text: "Visit Your EAP" (can be overridden with Label Override)</li>
				<li>Default group code label: "Enter group code" (can be overridden with Group Code Label Override)</li>
			</ul>

			<p><strong>Call EAP Button</strong></p>
			<ul>
				<li>Requires a Phone number</li>
				<li>Phone number is displayed next to the button</li>
				<li>Default button text: "Call Your EAP" (can be overridden with Label Override)</li>
			</ul>

			<p><strong>Button Placement</strong></p>
			<ul>
				<li>Both buttons appear in the "Get Support Anytime" section on the home page</li>
				<li>Only Button 1 (the primary CTA) appears in other locations (Learn More, When You Need Help, App Download)</li>
			</ul>

			<p><strong>Register Button Label</strong></p>
			<ul>
				<li>Leave empty and the "When you need help getting help" section shows the standard Visit/Call EAP button</li>
				<li>Enter a label (for example "REGISTER TODAY") and that section switches to a Register button instead</li>
				<li>The Register button links to the <em>CTA Button 1 URL</em> and shows the <em>CTA Button 1 Group Code</em> beneath it</li>
				<li>Only changes that one section &mdash; the "Get Support Anytime" buttons are unaffected</li>
			</ul>
		</div>

		<h4>Hero Images</h4>
		<div class="rule-section">
			<p><strong>Background Images</strong></p>
			<ul>
				<li>Home page: Uses "Home Hero Image Override" if provided, otherwise shows default hero image</li>
				<li>Learn More page: Uses "Learn More Hero Image Override" if provided, otherwise shows default image</li>
				<li>Allows each employer to have custom hero imagery</li>
			</ul>
		</div>

		<h4>Branding &amp; Logos</h4>
		<div class="rule-section">
			<p><strong>Overview</strong></p>
			<ul>
				<li>Four independent image slots in the "Branding" category &mdash; each is optional</li>
				<li>Each slot takes <strong>one</strong> file. Where a lockup shows two brands side by side ("Premier Health | one morning"), that is still a single combined image, not two uploads</li>
				<li>Leave a slot empty and the site falls back to its standard behaviour, described below</li>
			</ul>

			<p><strong>Header Logo Override</strong></p>
			<ul>
				<li>Replaces the One Morning logo in the site header on every page</li>
				<li>Empty = standard One Morning logo</li>
			</ul>

			<p><strong>Footer Logo Override</strong></p>
			<ul>
				<li>Replaces <em>both</em> footer logos (One Morning and the employer logo) with one banner</li>
				<li>Intended to be a <strong>different</strong> banner from the header, not the same file again</li>
				<li>Empty = standard two-logo footer</li>
			</ul>

			<p><strong>Well-Being Section Logo</strong></p>
			<ul>
				<li>Sits under the paragraph in the dark well-being section on the home page</li>
				<li>Empty = no logo (the section simply ends after the copy)</li>
			</ul>

			<p><strong>Dashboard Logo</strong></p>
			<ul>
				<li>Sits at the bottom of the yellow "Get support anytime" panel &mdash; bottom-right on desktop, centred on mobile</li>
				<li>Empty = no logo</li>
			</ul>

			<p><strong>Preparing the artwork</strong></p>
			<ul>
				<li><strong>Trim the file to the artwork.</strong> Transparent padding around the logo counts as part of the image, so a padded file renders noticeably smaller than expected. Crop tight to the ink before uploading</li>
				<li><strong>Header, Footer and Well-Being logos sit on a dark background</strong> &mdash; supply white or light artwork</li>
				<li><strong>The Dashboard Logo sits on the yellow panel</strong> &mdash; supply dark artwork</li>
				<li>Use PNG with a transparent background. The site scales each slot to a set width, so the file only needs to be at least that wide (roughly 2&times; for sharpness on retina screens)</li>
			</ul>
		</div>

		<h4>Well-Being Section</h4>
		<div class="rule-section">
			<p>The dark section under the home page hero. All three fields live in the "Well-Being Section" category and behave the same way: <strong>leave one empty and the standard One Morning wording is used</strong>; fill it in and your text replaces it for this employer only.</p>
			<ul>
				<li><strong>Well-Being Preheadline</strong> &mdash; the small all-caps line above the headline. Standard: "A New Morning for Employee Wellness"</li>
				<li><strong>Well-Being Headline</strong> &mdash; the large headline. Standard: "Your well-being matters."</li>
				<li><strong>Well-Being Text</strong> &mdash; the paragraph beneath it</li>
			</ul>
			<p>Keep the headline short. On mobile it is set at the same size as the hero copy, and a long headline will wrap onto extra lines.</p>
		</div>

		<h4>Custom Support Content</h4>
		<div class="rule-section">
			<p><strong>"Get Support Anytime" Section</strong></p>
			<ul>
				<li>By default, shows three standard paragraphs about EAP support</li>
				<li>If "Get Support Anytime Override" has content, it completely replaces the default paragraphs</li>
				<li>Allows employers to write their own messaging about support availability</li>
			</ul>
		</div>

		<h4>Conditional Sections</h4>
		<div class="rule-section">
			<p><strong>EAP Application Download Section</strong></p>
			<ul>
				<li>Only appears if "Show This Section" is set to true</li>
				<li>When shown, displays custom QR code, app logo, app name, and store links</li>
				<li>Allows hiding this entire section if the employer doesn't have an app</li>
			</ul>

			<p><strong>Contact Information</strong></p>
			<ul>
				<li>Only displays if phone number OR email is provided</li>
				<li>Shows heading "Contact your EAP for more info" (or translated equivalent)</li>
				<li>Hides entirely if no contact info exists</li>
			</ul>
		</div>

		<h4>Dynamic Access Information</h4>
		<div class="rule-section">
			<p>The "Get Support Anytime" section automatically builds a list showing:</p>
			<ul>
				<li><strong>Free visits:</strong> Number of free counseling sessions (if provided)</li>
				<li><strong>24/7 Access:</strong> Availability information (if provided)</li>
				<li><strong>Phone support:</strong> Toll-free number (if provided)</li>
				<li><strong>Text support:</strong> Text messaging details (if provided)</li>
				<li><strong>Up to 3 custom items:</strong> Additional custom access methods (if provided)</li>
			</ul>
			<p>Each item only appears if its data exists in the content.</p>
		</div>

		<h4>Phone Number Handling</h4>
		<div class="rule-section">
			<ul>
				<li>Phone numbers are automatically formatted for display</li>
				<li>Phone numbers in links are sanitized (only digits kept) for proper "tel:" links</li>
				<li>If no phone number exists, phone-related sections hide automatically</li>
			</ul>
		</div>

		<h4>Group Code Display</h4>
		<div class="rule-section">
			<ul>
				<li>Group code is configured per CTA button in the "CTA Buttons" category</li>
				<li>Only available for "Visit EAP" type buttons</li>
				<li>Shows group code with a label next to the button if the code exists</li>
				<li>Label can be customized via the Group Code Label Override field</li>
			</ul>
		</div>

		<h4>Translation Aware</h4>
		<div class="rule-section">
			<p>All customizable text goes through the translation system, so:</p>
			<ul>
				<li>Default text gets translated to selected language</li>
				<li>Override text gets translated to selected language</li>
				<li>HTML formatting (bold, italics, links) is preserved in translations</li>
			</ul>
		</div>
	</div>
</p-dialog>
